module.exports = `${require.publicPath}sby-icon.4d8a7706.webp`;